module.exports = __webpack_public_path__ + "static/media/szamlak2.cf87654e.jpg";